interface VNodeProps {
  class: object
  on: object
  style: object
}

interface VNode {
  props: VNodeProps
}

export default function patch (prevNode: VNode, nextNode: VNode, el: HTMLElement) {
  const { props: { class: nextNodeClass } } = nextNode
  const { props: { class: prevNodeClass } } = prevNode

  for (let className in nextNodeClass) {
    const value = nextNodeClass[className]
    if (prevNodeClass[className] !== value) {
      el.classList[value ? 'add' : 'remove'](className)
    }
  }
}
